export enum PaymentType {
  TICKET = 'BOLETO',
  CARD = 'CARTAO_DE_CREDITO',
}
